import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["elementType", "onPress", "onPressStart", "onPressEnd", "onClick", "isDisabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { filterDOMProps as $kKV4x$filterDOMProps, mergeProps as $kKV4x$mergeProps } from "@react-aria/utils";
import { useFocusable as $kKV4x$useFocusable } from "@react-aria/focus";
import { usePress as $kKV4x$usePress } from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $298d61e98472621b$exports = {};
$parcel$export($298d61e98472621b$exports, "useLink", function () {
  return $298d61e98472621b$export$dcf14c9974fe2767;
});

function $298d61e98472621b$export$dcf14c9974fe2767(props, ref) {
  var _props$elementType = props.elementType,
      elementType = _props$elementType === void 0 ? 'a' : _props$elementType,
      onPress = props.onPress,
      onPressStart = props.onPressStart,
      onPressEnd = props.onPressEnd,
      deprecatedOnClick = props.onClick,
      isDisabled = props.isDisabled,
      otherProps = _objectWithoutProperties(props, _excluded);

  var linkProps;
  if (elementType !== 'a') linkProps = {
    role: 'link',
    tabIndex: !isDisabled ? 0 : undefined
  };

  var _$kKV4x$useFocusable = $kKV4x$useFocusable(props, ref),
      focusableProps = _$kKV4x$useFocusable.focusableProps;

  var _$kKV4x$usePress = $kKV4x$usePress({
    onPress: onPress,
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    isDisabled: isDisabled,
    ref: ref
  }),
      pressProps = _$kKV4x$usePress.pressProps,
      isPressed = _$kKV4x$usePress.isPressed;

  var domProps = $kKV4x$filterDOMProps(otherProps, {
    labelable: true
  });
  var interactionHandlers = $kKV4x$mergeProps(focusableProps, pressProps);
  return {
    isPressed: isPressed,
    linkProps: $kKV4x$mergeProps(domProps, _objectSpread(_objectSpread(_objectSpread({}, interactionHandlers), linkProps), {}, {
      'aria-disabled': isDisabled || undefined,
      onClick: function onClick(e) {
        pressProps.onClick(e);

        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    }))
  };
}

export { $298d61e98472621b$export$dcf14c9974fe2767 as useLink };